import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-credit-note-confirmation',
  templateUrl: './credit-note-confirmation.component.html',
  styleUrls: ['./credit-note-confirmation.component.scss']
})
export class CreditNoteConfirmationComponent implements OnInit {

  @Input() entity
  constructor() { }

  ngOnInit(): void {
  }

}
